import { render, staticRenderFns } from "./tournamentReports.vue?vue&type=template&id=f5d35e5c&scoped=true"
import script from "./tournamentReports.vue?vue&type=script&lang=js"
export * from "./tournamentReports.vue?vue&type=script&lang=js"
import style0 from "./tournamentReports.vue?vue&type=style&index=0&id=f5d35e5c&prod&scoped=true&lang=css"
import style1 from "@/css/orginalReportCard.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/css/playerReportCard.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d35e5c",
  null
  
)

export default component.exports